import { instanceApi } from '../../services';
import { EditCampaign, EditCampaignRule, UpdatePriorityRule } from './CashbackModel';

const path = '/api/cashback/campaign';
const rulePath = '/api/cashbackcampaign/rule';

export const addCampaign = (campaign: EditCampaign): Promise<any> => instanceApi.post(path, campaign);

export const editCampaign = (campaignId: number, campaign: EditCampaign): Promise<any> => instanceApi.put(`${path}/${campaignId}`, campaign);

export const getCampaign = (campaignId: number): Promise<any> => instanceApi.get(`${path}/${campaignId}`);

export const deleteCampaign = (campaignId: number): Promise<any> => instanceApi.delete(`${path}/${campaignId}`);

export const getAllCampaigns = (partnerId: number): Promise<any> => instanceApi.get(`${path}/all?partnerId=${partnerId}`);

export const getClientsForCampaign = (partnerId: number): Promise<any> => instanceApi.get(`${path}/client?partnerId=${partnerId}`);

export const enableCampaign = (campaignId: number, isEnabled: boolean): Promise<any> => instanceApi.put(`${path}/${campaignId}/enabled`, { isActive: isEnabled });

export const getPartnershipsAccountTypes = (campaignId: number): Promise<any> => instanceApi.get(`${path}/${campaignId}/rule/setup`);

export const getRule = (ruleId: number): Promise<any> => instanceApi.get(`${rulePath}/${ruleId}`);

export const addRule = (rule: EditCampaignRule): Promise<any> => instanceApi.post(`${rulePath}`, rule);

export const editRule = (rule: EditCampaignRule, ruleId: number): Promise<any> => instanceApi.put(`${rulePath}/${ruleId}`, rule);

export const deleteRule = (ruleId: number): Promise<any> => instanceApi.delete(`${rulePath}/${ruleId}`);

export const getRuleSetup = (campaignId: number): Promise<any> => instanceApi.get(`${path}/${campaignId}/rule/setup`);

export const updateRulesPriority = (updateModel: UpdatePriorityRule): Promise<any> => instanceApi.put(`${rulePath}/priority`, updateModel);

export const getCashbackPayments = (): Promise<any> => instanceApi.get('/api/cashback/payments');
